export const fbSessionKeys = () => {
    return Object.keys(sessionStorage).filter((key) => /fbssls_/.test(key));
};
export const removeFbSession = () => {
    const keys = fbSessionKeys();
    if (keys.length) {
        keys.map((key) => sessionStorage.removeItem(key));
    }
};
